import { Box, Typography } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PIS, { API_URL } from "../../../api/api";
import AddAlertMessage from "../../../components/alert/Alert";
import { ERROR, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";
import { AppUtils } from "../../../utils/appUtils";
import RegisterFilter from "../../../components/register-filter/RegisterFilter";
import PublicRepresentativeList from "../public-representative/helpers/PublicRepresentativeList";
import { setTenureDateFrom, setTenureDateTo } from "../../../reduxToolkit/reducers/searchFilterSlice";

const ExecutiveMembers = () => {
  const dispatch = useDispatch();
  const printComponentRef = useRef();

  const [tableData, setTableData] = useState([]);
  const [size, setSize] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const { searchText, pageNumber, rowsPerPage, publicRepresentativePost, tenureDateFrom, tenureDateTo } = useSelector((state) => state.searchFilter);

  useEffect(() => {
    if (tenureDateFrom && tenureDateTo) {
      getPublicRepresentatives();
    }
  }, [pageNumber, rowsPerPage, searchText, tenureDateFrom, tenureDateTo, publicRepresentativePost]);

  const getPublicRepresentatives = () => {
    setIsLoading(true);

    let url = `${API_URL.publicRepresentative}?pageNumber=${pageNumber}&rowSize=${rowsPerPage}&committeeMember=${true}&tenureFrom=${tenureDateFrom}&tenureTo=${tenureDateTo}`;

    if (searchText) url += `&searchParam=${searchText}`;
    if (publicRepresentativePost) url += `&post=${publicRepresentativePost}`;

    PIS.get(url)
      .then((response) => {
        const jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setTableData(jsondata.data?.objectList || []);
          setSize(jsondata.data.size || 0);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
        setIsLoading(false);
      })
      .catch(() => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
        setIsLoading(false);
      });
  };

  const fieldVisibility = {
    publicRepresentativePost: true,
    tenureDateFilter: true
  };

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        borderBottom={1}
        mb={3}
        pb={1}
      >
        <Typography variant="h5">कार्यपालिका सधस्यहरु</Typography>
      </Box>
      <RegisterFilter
        fieldVisibility={fieldVisibility}
        showSearchField={true}
        searchFieldLabel="नाम बाट खोज्नुहोस्"
        defaultTenureFromDate={1649894400000}
        defaultTenureToDate={1807660800000}
      />
      <Box ref={printComponentRef}>
        <PublicRepresentativeList
          isLoading={isLoading}
          size={size}
          rowsPerPage={rowsPerPage}
          getTableData={getPublicRepresentatives}
          tableData={tableData}
          showActionColumn={false}
          pageSize={pageNumber}
        />
      </Box>
    </Box>
  );
}

export default ExecutiveMembers
